import React, { useEffect, useState } from "react";
import {
  formatHours,
  getStatusTone,
  isValidHoursValue,
  normalizeHoursInput,
} from "../../utils/timesheetUtils";

const ManHourCell = ({
  cellKey,
  value,
  draftValue,
  status,
  disabled,
  onDraftChange,
}) => {
  const [draft, setDraft] = useState(
    draftValue ?? (value === 0 ? "" : formatHours(value))
  );
  const [inputError, setInputError] = useState("");

  useEffect(() => {
    setDraft(draftValue ?? (value === 0 ? "" : formatHours(value)));
    if (status !== "error") setInputError("");
  }, [draftValue, status, value]);

  const handleChange = (event) => {
    const nextValue = event.target.value;
    const normalized = normalizeHoursInput(nextValue);
    setDraft(nextValue);
    onDraftChange(normalized);
    if (!isValidHoursValue(normalized)) {
      setInputError("กรุณาระบุชั่วโมงตั้งแต่ 0 และไม่เกิน 24 ชั่วโมง");
    } else {
      setInputError("");
    }
  };

  return (
    <div className="min-w-[72px] text-center">
      <input
        key={cellKey}
        type="number"
        min="0"
        max="24"
        step="0.25"
        value={draft}
        disabled={disabled}
        onChange={handleChange}
        placeholder="-"
        className={[
          "w-full rounded-lg border bg-white dark:bg-gray-800 px-2 py-2 text-center text-sm text-gray-800 dark:text-gray-100 outline-none transition",
          inputError
            ? "border-red-400 focus:ring-2 focus:ring-red-300"
            : "border-gray-200 dark:border-gray-700 focus:ring-2 focus:ring-indigo-300",
          disabled ? "cursor-not-allowed opacity-70" : "",
        ].join(" ")}
      />

      <p className={`mt-1 text-[11px] ${inputError ? "text-red-500" : getStatusTone(status)}`}>
        {inputError || (status === "draft"
          ? "รอบันทึก"
          : status === "saved"
          ? "บันทึกแล้ว"
          : status === "error"
          ? "เกิดข้อผิดพลาด"
          : " ")}
      </p>
    </div>
  );
};

export default ManHourCell;
